// require ../uncategorized/wizard.js

window.init = function() {

    console.log("init accessed!")

    checkUserAgreed();
    initCookiesEu();
    // enable_fixed_table_headers();
    // initScrollHint();

    // $('.bootstrap-switch').each(function () {
    //     $this = $(this);
    //     data_on_label = $this.data('on-label') || '';
    //     data_off_label = $this.data('off-label') || '';
    //
    //     $this.bootstrapSwitch({
    //         onText: data_on_label,
    //         offText: data_off_label
    //     });
    // });

    // $('.pagination a').click(function(event) {
    //     event.preventDefault();
    //     $.ajax({type: 'GET',
    //         url:  $(this).attr('href'),
    //         dataType: 'script'
    //     });
    //     return false;
    // });
    //
    //
    // $("body").on("click", ".delete-row-button", function() {
    //     $($(this).closest(".license_row")[0]).remove();
    // });
    $('.collapse').on('shown.bs.collapse', function(){
        $("table.floatThead-table").trigger('reflow');
    }).on('hidden.bs.collapse', function(){
        $("table.floatThead-table").trigger('reflow');
    });
}

window.showLoadingSpinner = function(){
    $(".loading_overlay").show();
}

window.hideLoadingSpinner = function(){
    $(".loading_overlay").hide();
}

window.showFlash = function(type, message, wait_for){
    // for details look: http://bootstrap-notify.remabledesigns.com/
    type = type === 'notice' ? 'info' : type;
    if (!wait_for) wait_for = 4000;

    $.notify({
        message: message
    },{
        type: type,
        delay: wait_for,
        allow_dismiss: true,
        placement: {
            from: 'top',
            align: 'left'
        },
        z_index: 9996,
        offset: { x: 20, y: 55 },
        template: '<div class="border-0 alert-dismissible alert alert-{0} fade show text-white col-auto" role="alert">' +
            '<span class="alert-icon">{1}</span> ' +
            '<span class="alert-text text-break">{2}</span>' +
            '<button type="button" class="btn-close fs-4 d-flex align-items-center" data-bs-dismiss="alert" aria-label="Close">'+
            '<span aria-hidden="true">&times;</span>'+
            '</button>'+
            '</div>'
    });
}

window.capitalize = function(string) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

window.autofillName = function(){
    $('[data-autofillname]').on('blur', function() {
        var email = $(this).val();
        if (email.length > 0) {
            var fullName = email.split('@')[0].split('.');
            var userName = capitalize(fullName[0]);
            if (fullName.length > 1) {
                userName += ' ' + capitalize(fullName[ fullName.length-1 ]);
            }
            var userNameId = $(this).data('autofillname');
            if (userNameId && $(userNameId) && $(userNameId).val().length == 0) {
                $(userNameId).val(userName);
            }
        }
    });
}

function enable_fixed_table_headers() {
  let width = $(window).width();
  // todo Fixed header not working when screen is sized for mobile (menu changed)
  if( width > 992 ) {
    $("table.floatThead").floatThead({
      responsiveContainer: function($table){
        return $table.closest('.table-responsive');
      }
    });
    setTimeout(function () {
      $("table.floatThead").trigger("reflow");
    }, 400);
  }
}

window.checkUserAgreed = function() {
    if ($('body').data('user-agreement-pending')) {
        $.ajax({
            type: 'GET',
            url: '/terms_and_conditions/pending_user_agreements.js',
            success: function(data) {
                eval(data);
            }
        });
    }
}

window.initCookiesEu = function() {
    windowIsTurbolinked = false;
    cookiesEu.init();
}

window.delay = function(callback, ms) {
    let timer = 0;
    return function() {
        let context = this, args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            callback.apply(context, args);
        }, ms || 0);
    };
}

window.month_difference = function(end_date, start_date) {
    return (end_date.getMonth()+1) - start_date.getMonth() + (12 * (end_date.getFullYear() - start_date.getFullYear()));
}

window.readDate = function(dateString) {
    let dateParts = dateString.split(" ");
    const monthNames = ["January", "February", "March", "April", "May", "June",
                        "July", "August", "September", "October", "November", "December"];
    const monthIndex = monthNames.indexOf(dateParts[0]);
    const year = parseInt(dateParts[1], 10);
    return new Date(year, monthIndex, 1);
}

function initScrollHint() {
  new ScrollHint('.table-responsive', {
    suggestiveShadow: true,
    remainingTime: 0
  });
}

window.responsiveRecaptcha = function(){

    $(function(){
        function rescaleCaptcha(){
            let width = $('.g-recaptcha').parent().width();
            let scale;
            if (width < 302) {
                scale = width / 302;
            } else{
                scale = 1.0;
            }

            $('.g-recaptcha').css('transform', 'scale(' + scale + ')');
            $('.g-recaptcha').css('-webkit-transform', 'scale(' + scale + ')');
            $('.g-recaptcha').css('transform-origin', '0 0');
            $('.g-recaptcha').css('-webkit-transform-origin', '0 0');
        }

        rescaleCaptcha();
        $( window ).resize(function() { rescaleCaptcha(); });

    });
};

window.hideModals = function () {
    const $modals =  document.querySelectorAll('.modal')
    $modals.forEach(modal => {
        let currentModal = bootstrap.Modal.getInstance(modal)
        if (currentModal) currentModal.hide()
    })
}

window.validateForm = function (form) {
    const isValid = form[0].checkValidity();
    form.addClass('was-validated');
    return isValid;
}

window.validateVisibleForm = function (form) {
    const visibleInputs = form.find('input:visible, select:visible');

    let isValid = true;

    visibleInputs.each(function() {
        if (!$(this)[0].checkValidity()) {
            isValid = false;
            return false;
        }
    });

    form.addClass('was-validated');
    return isValid;
}

window.reflowFloatThead = function() {
    $('.fixed-table-header').each(function() {
        $(this).trigger("reflow");
    });
}

window.recaptchaResponse = function() {
    const event = new Event("recaptcha:success");
    window.dispatchEvent(event);
}

window.dateFormatter = function (date_string, current_format = window.serverSideDateFormat, new_format = window.userPreferenceDateFormat) {
    const date_value = moment(date_string, current_format);
    const formatted_date_value = moment(date_value).format(new_format);
    return formatted_date_value;
}

window.dateConvertor = function(element) {
    const date_string = element.is('input, textarea, select') ? element.val() : element.text();
    const formatted_date = window.dateFormatter(date_string);

    if (formatted_date !== 'Invalid date')
        element.is('input, textarea, select') ? element.val(formatted_date) : element.text(formatted_date);
}
